import React from 'react';
import {Link} from './Components.js';

export default function ShortBio() {
  return <div id="about"
      style={{
        maxWidth:'100vw',
        // height:'94vh',
        padding:10,
        paddingTop:200,
        paddingBottom:200,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        backgroundColor:'var(--primary-bg-color)'
  }}>
    <p style={{
        fontSize:'max(22px, min(calc(5vw + 6px), 34px))',
        textShadow:'0px 0px 3px var(--primary-bg-color)', 
        fontWeight:'bold',
        zIndex:1,
        color:'var(--primary-text-color)'}}>
        Full stack developer & builder of open source&nbsp;
        <Link 
          target="_blank"
          rel="noopener noreferrer"
          href="https://github.com/tudorelu/pyjuque">
          algo trading tools
        </Link>. 
        Independent researcher, recently published&nbsp;
        <Link 
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.researchgate.net/publication/349515274_A_Self-Adaptive_Deep_Learning-Based_Algorithm_for_Predictive_Analysis_of_Bitcoin_Price"> 
          📝
        </Link> &&nbsp;
        <Link 
          target="_blank"
          rel="noopener noreferrer"
          href="https://ieeexplore.ieee.org/document/9650873"> 
          📝
        </Link>,
        currently studying machine learning.
      </p>
      <p style={{
          fontWeight:'normal',
          fontSize:'max(16px, min(calc(3vw + 6px), 22px))', 
          color:'var(--primary-text-color)'}}>
        In 2019 I co-founded a&nbsp;
        <Link 
          target="_blank"
          rel="noopener noreferrer"
          href="https://eazitrip.com"> 
          start-up
        </Link> in the AR & travel industry. 
        Before that I worked as a programmer on a handful of major 
        software projects (mostly full-stack).
        <br/><br/><br/>
        Bachelor's from ANU in 2017.
        While studying, I developed a game inspired by Pokemon Go for the ANU campus 
        & I was a tutor for several computing courses.
        <br/><br/><br/>
        I enjoy bouldering 🧗‍♂️ & lately I'm developing a passion 
        for coffee. 
    </p>
  </div>;
}
